<template>
    <div>
        <!-- 导航栏 -->
        <van-nav-bar
                title="个人信息"
                right-text="编辑资料"
                left-arrow
                @click-left="onClickLeft"
        />
        <van-form validate-first @submit="submit">
            <van-field
                    label="姓名"
                    v-model="name"
                    name="validator"
                    placeholder="请输入姓名"
                    maxlength="10"
                    autosize
                    :rules="[{ validator, message: `请输入姓名`}]"
            />
            <van-field
                    label="手机号码"
                    v-model="phone"
                    placeholder="请输入11位手机号"
                    maxlength="11"
                    autosize
                    :rules="[{ validator:phoneValidator, message: `电话号码不正确`}]"
            />


            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit" >
                    提交
                </van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
  import axios from '../common/axios'
  import {responseCodes} from '../common/const'
  import {Toast} from 'vant'
  export default {
    name: "PersonalData",
    data() {
      return {
        name: this.$store.state.user.name,
        phone:this.$store.state.user.phone
      };
    },
    methods:{

      validator(val) {
        return val.trim().length>0
      },

      phoneValidator(val){
        return /^1[3456789]\d{9}$/.test(val)
      },
      async submit(){
        this.$store.commit("showOverlay")
        let user = {
          name: this.name,
          phone:this.phone,
          openId:this.$store.state.user.openId
        };
        try {
          let response = await axios.post("/fyserve/user/editUser" ,user)
          let data = response.data;
          if (data.code === responseCodes.success) {
            this.$store.commit('setUser',data.data)
            this.$router.back();
          }else{
            Toast.fail(data.message);
          }
        }catch (e) {
          console.error(e)
          Toast.fail("加载数据失败")
        }finally {
          this.$store.commit("hideOverlay")
          this.name = '';
          this.phone = ''
        }
      },

      onClickLeft() {
        this.$router.back();
      },
    }
  }
</script>

<style scoped>

</style>